import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import { HomePage } from './pages/HomePage';
import { ToursListPage } from './pages/ToursListPage';
import { TourDetailPage } from './pages/TourDetailPage';
import { DestinationDetailPage } from './pages/DestinationDetailPage';
import { HeritageWalksPage } from './pages/HeritageWalksPage';
import { HeritageWalkDetailPage } from './pages/HeritageWalkDetailPage';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <div className="App">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/tours" element={<ToursListPage />} />
              <Route path="/tours/:slug" element={<TourDetailPage />} />
              <Route path="/destinations/:slug" element={<DestinationDetailPage />} />
              <Route path="/heritage-walks" element={<HeritageWalksPage />} />
              <Route path="/heritage-walks/:slug" element={<HeritageWalkDetailPage />} />
            </Routes>
            <Toaster />
          </div>
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;